export interface GenericObject {
	[key: string]: GenericObject;
}

export function getDataOfObjectAtPath(path: string[], data: GenericObject | undefined): GenericObject | undefined {
	return path.reduce((prev, curr) => prev?.[curr], data);
}

export function setDataOfObjectAtPath(path: string[], data: GenericObject, dataToSet: GenericObject) {
	return path.reduceRight((prev, curr, i) => {
		const pathToGo = path.slice(0, i);
		const originalDataAtPath = getDataOfObjectAtPath(pathToGo, data) ?? {};

		return {
			...originalDataAtPath,
			[curr]: prev
		};
	}, dataToSet);
}
